module.exports = __webpack_public_path__ + "static/media/SBI1.91846379.png";